var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 879,
    height: 519,
    viewBox: "0 0 879 519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 879,
    height: 519,
    fill: "#141414"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.582 333.435L388.282 335.333L388.285 331.532C388.285 331.532 388.239 333.476 389.118 333.962C389.979 334.438 391.582 333.435 391.582 333.435Z",
    fill: "#8E3315"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.907 329.514C325.504 364.616 357.311 390.901 395.331 402.594C433.35 414.289 474.467 410.43 509.638 391.867C544.809 373.304 571.151 341.558 582.87 303.611C594.59 265.665 590.646 224.626 572.049 189.525C588.818 242.276 530.434 260.808 530.434 260.808L459.771 297.67L386.333 335.9C386.333 335.9 336.281 368.06 306.907 329.514Z",
    fill: "#473ADE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.644 329.772C325.241 364.874 357.048 391.164 395.068 402.858C433.086 414.553 474.204 410.694 509.375 392.131C544.546 373.568 570.888 341.821 582.607 303.875C594.327 265.929 590.463 224.89 571.866 189.789C588.635 242.541 530.171 261.072 530.171 261.072L459.508 297.933L386.07 336.163C386.07 336.163 336.018 368.318 306.644 329.772Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.806 258.144L533.816 259.769L529.536 261.317C529.536 261.317 531.737 260.557 532.051 259.721C532.359 258.901 530.806 258.144 530.806 258.144Z",
    fill: "#292282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.957 327.946C591.117 292.618 594.472 251.535 582.283 213.736C570.094 175.937 543.361 144.518 507.963 126.391C472.565 108.264 431.402 104.913 393.531 117.077C355.66 129.24 324.181 155.92 306.021 191.248C339.72 147.299 388.442 184.496 388.442 184.496L459.205 221.166L532.682 259.32C532.682 259.32 587.769 281.829 572.957 327.946Z",
    fill: "#D71D6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.596 327.804C590.702 292.581 594.047 251.62 581.895 213.934C569.742 176.248 543.088 144.923 507.795 126.849C472.502 108.776 431.463 105.436 393.704 117.562C355.945 129.689 324.561 156.29 306.455 191.514C340.053 147.695 388.63 184.782 388.63 184.782L459.182 221.341L532.441 259.382C532.441 259.382 587.363 281.824 572.596 327.804Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.305 188.047L388.243 184.067L391.728 186.004C391.728 186.004 389.969 184.972 389.076 185.529C388.201 186.073 388.305 188.047 388.305 188.047Z",
    fill: "#741039"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.5 109.85C399.717 109.85 361.565 125.625 333.434 153.704C305.304 181.783 289.5 219.866 289.5 259.576C289.5 299.286 305.304 337.369 333.434 365.449C361.565 393.528 399.717 409.302 439.5 409.302C388.443 400.746 388.443 334.722 388.443 334.722V259.576V183.101C388.443 183.101 388.443 118.971 439.5 109.85Z",
    fill: "#FF5B25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.5 109.5C399.717 109.5 361.565 125.275 333.434 153.354C305.304 181.433 289.5 219.516 289.5 259.226C289.5 298.936 305.304 337.019 333.434 365.098C361.565 393.177 399.717 408.952 439.5 408.952C388.443 392.67 388.443 334.803 388.443 334.803V259.411V184.499C388.443 184.499 386.585 119.203 439.5 109.5Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.5 109.5C399.717 109.5 361.565 125.275 333.434 153.354C305.304 181.433 289.5 219.516 289.5 259.226C289.5 298.936 305.304 337.019 333.434 365.098C361.565 393.177 399.717 408.952 439.5 408.952C388.443 392.67 388.443 334.803 388.443 334.803V259.411V184.499C388.443 184.499 386.585 119.203 439.5 109.5Z",
    fill: "url(#paint3_linear)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.104 409.237C388.44 386.205 388.5 334.784 388.5 334.784C388.5 334.784 325.705 370.14 304.565 324.919C304.565 324.919 340.003 409.537 439.104 409.237Z",
    fill: "#473ADE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 571.877,
    y1: 242.505,
    x2: 354.031,
    y2: 458.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655513,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 349.6,
    y1: 161.381,
    x2: 650.34,
    y2: 216.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 369.83,
    y1: 390.404,
    x2: 280.901,
    y2: 115.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675464,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 369.83,
    y1: 390.404,
    x2: 280.901,
    y2: 115.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675464,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.88db95f96e6a783745cf6bdfe4745dd6.svg";
export { ForwardRef as ReactComponent };